import React, { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

const GarmentCamera = ({ itemId, qrcode, onClose, onCapture }) => {
  const webcamRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(null);
  const [error, setError] = useState("");

  const capture = useCallback(() => {
    if (!webcamRef.current) return;

    const imageSrc = webcamRef.current.getScreenshot();

    if (!imageSrc) {
      setError("Unable to capture image.");
      return;
    }

    setImgSrc(imageSrc);
  }, []);

  const handleUserMediaError = useCallback((error) => {
    console.error("Camera error:", error);
    setError("Unable to access camera. Please allow camera permission.");
  }, []);

  const retake = () => {
    setImgSrc(null);
  };

  const confirmImage = () => {
    if (!imgSrc) return;

    onCapture({
      imageSrc: imgSrc,
      itemId,
      qrcode,
    });
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.8)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          width: "100%",
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        <h2>Garment Camera</h2>

        {error && (
          <p style={{ color: "red" }}>
            {error}
          </p>
        )}

        {!imgSrc ? (
          <>
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              videoConstraints={{
                facingMode: { ideal: "environment" },
              }}
              style={{
                width: "100%",
                maxWidth: "480px",
                borderRadius: "8px",
              }}
              onUserMediaError={handleUserMediaError}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={capture}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#1752AA",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Capture Photo
              </button>

              <button
                onClick={onClose}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#777",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </>
        ) : (
          <>
            <h3>Preview</h3>

            <img
              src={imgSrc}
              alt="Captured garment"
              style={{
                width: "100%",
                maxWidth: "480px",
                borderRadius: "8px",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={retake}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#777",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Retake
              </button>

              <button
                onClick={confirmImage}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "green",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Use Photo
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GarmentCamera;
